import React from 'react'

export const TABLE_CONTEXT = React.createContext(null)
